export default __webpack_public_path__ + "static/media/selected-for-dev.57335f65.svg";